import { ChangeDetectionStrategy, Component, effect, inject, input, signal } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { TranslateModule } from '@ngx-translate/core';

/**
 * Componente que muestra un horario en HTML y lo sanitiza antes de renderizarlo.
 */
@Component({
  selector: 'app-schedule-card',
  imports: [TranslateModule],
  templateUrl: './schedule-card.html',
  styleUrl: './schedule-card.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ScheduleCard {
  /**
   * Servicio de Angular utilizado para sanitizar HTML y prevenir inyecciones.
   * @private
   */
  private readonly sanitizer = inject(DomSanitizer);

  /**
   * Entrada requerida con el HTML del horario que se desea mostrar.
   */
  readonly schedule = input.required<string>();

  /**
   * Contenedor seguro que almacenará el HTML del horario ya sanitizado.
   * Se usa SafeHtml para indicar que el contenido es seguro para bindear en la plantilla.
   */
  protected readonly scheduleSafe = signal<SafeHtml>('');

  /**
   * Constructor del componente; crea un efecto que sanitiza `schedule`
   * cada vez que cambia y actualiza `scheduleSafe`.
   */
  constructor() {
    effect(() => {
      const schedule = this.schedule();

      if (schedule) {
        // Asigna de manera segura el HTML del horario para evitar inyecciones.
        const secureHtml = this.sanitizer.bypassSecurityTrustHtml(schedule);
        this.scheduleSafe.set(secureHtml);
      }
    });
  }
}
